<template>
    <div>
        <el-row style="margin-top: 2vh; padding: 20px;">
            <!-- 搜索表单区域 -->
            <el-col :span="24">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="仓库">
                        <el-select v-model="searchForm.houseId" filterable placeholder="仓库" clearable @change="getList">
                            <el-option v-for="item in warehouseOptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="编码">
                        <el-input v-model="searchForm.code" placeholder="请输入编码"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getList()" icon="el-icon-search">查询</el-button>
                        <el-button @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
                        <el-button type="primary" icon="el-icon-plus" @click="showAddDialog()">新增</el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 表格区域 -->
            <el-col :span="24" style="margin-top: 20px;">
                <el-table ref="tableRef" :data="list.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
                    height="65vh" style="width: 100%;" border :header-cell-class-name="'table-header'"
                    @row-click="handleRowClick" v-loading="loading">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="code" label="编码" align="center" />
                    <el-table-column prop="name" label="名字" align="center" />
                    <el-table-column prop="line" label="行" align="center" />
                    <el-table-column prop="rowNum" label="列" align="center" />
                    <el-table-column prop="layer" label="层" align="center" />
                    <el-table-column prop="grid" label="格" align="center" />

                    <el-table-column label="操作" align="center" width="200">
                        <template #default="scope">
                            <!-- <el-button type="text" size="small" @click="showEditDialog(scope.row)">修改</el-button>
                            <el-button type="text" size="small" class="text-red-500"
                                @click="handleDelete(scope.row.id)">删除</el-button> -->
                            <el-button size="mini" type="primary" icon="el-icon-edit"
                                @click="showEditDialog(scope.row)">修改</el-button>
                            <el-button type="danger" icon="el-icon-delete" @click="handleDelete(scope.row.id)"
                                size="small">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页区域 -->
                <div style="margin-top: 20px; text-align: center;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <!-- 新增/修改弹窗 -->
        <el-dialog :title="isEdit ? '修改信息' : '新增信息'" :visible.sync="dialogVisible" width="600px" :z-index="2000"
            append-to-body modal-append-to-body>
            <el-form :model="formData" :rules="formRules" ref="formRef" label-width="120px" class="mt-4">
                <el-form-item label="所属仓库" prop="houseId">
                    <el-select v-model="formData.houseId" placeholder="请选择仓库" filterable
                        @change="handleWarehouseChange">
                        <el-option v-for="item in warehouseOptions" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="编码" prop="code">
                    <el-input v-model="formData.code" placeholder="请输入编码" />
                </el-form-item>
                <el-form-item label="名字" prop="name">
                    <el-input v-model="formData.name" placeholder="请输入行号" />
                </el-form-item>
                <el-form-item label="行" prop="line">
                    <el-input v-model.number="formData.line" placeholder="请输入行号" />
                </el-form-item>
                <el-form-item label="列" prop="rowNum">
                    <el-input v-model.number="formData.rowNum" placeholder="请输入列号" />
                </el-form-item>
                <el-form-item label="层" prop="layer">
                    <el-input v-model.number="formData.layer" placeholder="请输入层数" />
                </el-form-item>
                <el-form-item label="格" prop="grid">
                    <el-input v-model.number="formData.grid" placeholder="请输入格数" />
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm()">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getAllHouse, addStorageLocation, getStorageLocation, deleteStorageLocation, updateStorageLocation } from "@/api/storagelocation";

export default {
    name: 'MaterialGrid',
    data() {
        return {
            warehouseOptions: [],
            searchForm: {
                houseId: '',
                code: ''
            },
            list: [],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            loading: false,
            dialogVisible: false,
            isEdit: false,
            formData: {
                id: '',
                code: '',
                line: null,
                rowNum: null,
                layer: null,
                grid: null,
                houseId: '', name: ''
            },
            formRules: {
                houseId: [
                    { required: true, message: '请选择所属仓库', trigger: 'change' }
                ],
                code: [
                    { required: true, message: '请输入编码', trigger: 'blur' }
                ],
                line: [
                    { required: true, message: '请输入行号', trigger: 'blur' },
                    { type: 'number', min: 1, message: '行号必须大于0', trigger: 'blur' }
                ],
                rowNum: [
                    { required: true, message: '请输入列号', trigger: 'blur' },
                    { type: 'number', min: 1, message: '列号必须大于0', trigger: 'blur' }
                ],
                layer: [
                    { required: true, message: '请输入层数', trigger: 'blur' },
                    { type: 'number', min: 1, message: '层数必须大于0', trigger: 'blur' }
                ],
                grid: [
                    { required: true, message: '请输入格数', trigger: 'blur' },
                    { type: 'number', min: 1, message: '格数必须大于0', trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        this.getWarehouseList();
    },
    methods: {
        async getWarehouseList() {
            try {
                this.loading = true;
                const response = await getAllHouse({
                    userId: localStorage.getItem('userId')
                });
                if (response.code === 200) {
                    this.warehouseOptions = response.data.map(item => ({
                        value: item.houseId,
                        label: item.houseName,
                        code: item.code
                    }));

                    // 关键修改：如果有仓库数据，默认选中第一个并查询
                    if (this.warehouseOptions.length > 0) {
                        this.searchForm.houseId = this.warehouseOptions[0].value;
                        // 自动填充第一个仓库的编码

                        // 触发查询
                        this.getList();
                    }
                } else {
                    this.$message.error("获取仓库列表失败：" + (response.msg || "未知错误"));
                }
            } catch (error) {
                console.error("获取仓库列表接口调用失败", error);
                this.$message.error("网络错误，无法获取仓库列表");
            } finally {
                this.loading = false;
            }
        },

        handleWarehouseChange(houseId) {
            console.log(houseId);
        },

        async getList() {
            try {
                this.loading = true;
                const params = {
                    userId: localStorage.getItem('userId'),
                    houseId: this.searchForm.houseId,
                    code: this.searchForm.code
                };

                const response = await getStorageLocation(params);
                if (response.code === 200) {
                    this.list = response.data.list || response.data || [];
                    this.totalCount = response.data.total || this.list.length;
                } else {
                    this.$message.error("获取位置列表失败：" + (response.msg || "未知错误"));
                    this.list = [];
                    this.totalCount = 0;
                }
            } catch (error) {
                console.error("获取位置列表接口调用失败", error);
                this.$message.error("网络错误，无法获取位置列表");
            } finally {
                this.loading = false;
            }
        },

        resetSearch() {
            this.searchForm = {
                houseId: '',
                code: ''
            };
            this.currentPage = 1;
            this.getList();
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getList();
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },

        showAddDialog() {
            this.isEdit = false;
            this.dialogVisible = true;
            this.formData = {
                id: '',
                code: '',
                line: null,
                rowNum: null,
                layer: null,
                grid: null,
                houseId: '', name: ''
            };
            this.$nextTick(() => {
                this.$refs.formRef?.clearValidate();
            });
        },

        showEditDialog(row) {
            this.isEdit = true;
            this.dialogVisible = true;
            this.formData = {
                ...row,
                line: Number(row.line),
                rowNum: Number(row.rowNum),
                layer: Number(row.layer),
                grid: Number(row.grid)
            };
            this.$nextTick(() => {
                this.$refs.formRef?.clearValidate();
            });
        },

        submitForm() {
            this.$refs.formRef.validate(async (isValid) => {
                if (isValid) {
                    try {
                        const baseParams = {
                            userId: localStorage.getItem('userId'),
                            code: this.formData.code,
                            houseId: this.formData.houseId,
                            line: this.formData.line,
                            rowNum: this.formData.rowNum,
                            layer: this.formData.layer,
                            grid: this.formData.grid,
                            name: this.formData.name
                        };

                        let params = this.isEdit ? { ...baseParams, id: this.formData.id } : baseParams;

                        if (this.isEdit) {
                            const response = await updateStorageLocation(params);
                            if (response.code === 200) {
                                this.$message.success("修改成功");
                                this.dialogVisible = false;
                                this.getList();
                            } else {
                                this.$message.error("修改失败：" + (response.msg || "未知错误"));
                            }
                        } else {
                            const response = await addStorageLocation(params);
                            if (response.code === 200) {
                                this.$message.success("新增成功");
                                this.dialogVisible = false;
                                this.getList();
                            } else {
                                this.$message.error("新增失败：" + (response.msg || "未知错误"));
                            }
                        }
                    } catch (error) {
                        console.error("提交表单接口调用失败", error);
                        this.$message.error("网络错误，操作失败");
                    }
                }
            });
        },

        handleDelete(id) {
            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const response = await deleteStorageLocation({
                        id: id,
                        userId: localStorage.getItem('userId')
                    });
                    if (response.code === 200) {
                        this.$message.success("删除成功");
                        this.getList();
                    } else {
                        this.$message.error("删除失败：" + (response.msg || "未知错误"));
                    }
                } catch (error) {
                    console.error("删除接口调用失败", error);
                    this.$message.error("网络错误，删除失败");
                }
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        handleRowClick(row) {
            this.$refs.tableRef.toggleRowSelection(row);
        }
    }
}
</script>

<style lang="scss" scoped>
.table-header {
    background-color: rgb(230, 242, 255) !important;
    font-weight: bold;
}

.text-red-500 {
    color: #f56c6c;
}

.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}

.el-dialog__body {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

.el-form-item {
    margin-bottom: 20px;
}

::v-deep .el-dialog__wrapper {
    z-index: inherit !important;
}
</style>